// Mapping enum DB → italiano UI (vedi convenzioni di naming nella spec)

export const ROLE_LABELS = {
  developer: "Sviluppatore",
  admin: "Admin",
  amministrazione: "Amministrazione",
  back_office: "Back Office",
  seller: "Venditore",
};

export const ROLE_BADGE_COLOR = {
  developer: "bg-purple-100 text-purple-800 border-purple-200",
  admin: "bg-blue-100 text-blue-800 border-blue-200",
  amministrazione: "bg-cyan-100 text-cyan-800 border-cyan-200",
  back_office: "bg-slate-100 text-slate-700 border-slate-200",
  seller: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export const PERMISSION_LABELS = {
  visualizza: "Visualizza",
  gestisci_impegno_contratto: "Gestisci impegno e contratto",
  crea_elimina_utenti: "Crea/elimina utenti",
  elimina_sostituisci_documenti: "Elimina/sostituisci documenti",
  gestione_incassi: "Gestione incassi",
  agire_su_pratica_venduta: "Agisci su pratica venduta",
  agire_su_pratica_consegnata: "Agisci su pratica consegnata",
  vendita_sotto_margine: "Vendita sotto margine minimo",
};

export const PERMISSION_FLAGS = Object.keys(PERMISSION_LABELS);

export function userFullName(u) {
  if (!u) return "";
  return `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.email || "";
}

export function userRoleLabel(u) {
  if (!u) return "";
  const r = u.role_default || (u.role || "").toLowerCase();
  return ROLE_LABELS[r] || r;
}

export function userRoleColor(u) {
  if (!u) return ROLE_BADGE_COLOR.back_office;
  const r = u.role_default || (u.role || "").toLowerCase();
  return ROLE_BADGE_COLOR[r] || ROLE_BADGE_COLOR.back_office;
}

// ========== Sprint 2A: Vehicles & Suppliers labels ==========
export const VEHICLE_STATUS_LABELS = {
  VIRTUAL: "Virtuale",
  INCOMING: "In arrivo",
  AVAILABLE: "Disponibile",
  RESERVED: "Impegnata",
  SOLD: "Venduta",
  DELIVERED: "Consegnata",
};

export const VEHICLE_STATUS_COLOR = {
  VIRTUAL: "bg-slate-100 text-slate-700 border-slate-200",
  INCOMING: "bg-sky-100 text-sky-800 border-sky-200",
  AVAILABLE: "bg-emerald-100 text-emerald-800 border-emerald-200",
  RESERVED: "bg-amber-100 text-amber-800 border-amber-200",
  SOLD: "bg-red-100 text-red-800 border-red-200",
  DELIVERED: "bg-violet-100 text-violet-800 border-violet-200",
};

// Hex palette usata dai grafici / inline styles
export const VEHICLE_STATUS_COLORS_HEX = {
  VIRTUAL: "#9E9E9E",
  INCOMING: "#03A9F4",
  AVAILABLE: "#4CAF50",
  RESERVED: "#FF9800",
  SOLD: "#F44336",
  DELIVERED: "#B71C1C",
};

// Sprint 2B.2-B: workflow rigido transizioni status.
// - VIRTUAL/INCOMING/AVAILABLE liberamente selezionabili tra loro (categoria 'forward', no motivo)
// - AVAILABLE→RESERVED, RESERVED→SOLD, SOLD→DELIVERED (categoria 'forward', richiedono data)
// - Sprint 4A.4 B1: rimosso AVAILABLE→SOLD diretto (rollback). SOLD solo da RESERVED.
// - Regressioni post-AVAILABLE (categoria 'backward', motivo + permesso)
export const VEHICLE_STATUS_FORWARD = {
  VIRTUAL: ["INCOMING", "AVAILABLE"],
  INCOMING: ["VIRTUAL", "AVAILABLE"],
  AVAILABLE: ["VIRTUAL", "INCOMING", "RESERVED"],
  RESERVED: ["SOLD"],
  SOLD: ["DELIVERED"],
  DELIVERED: [],
};
export const VEHICLE_STATUS_BACKWARD = {
  VIRTUAL: [],
  INCOMING: [],
  AVAILABLE: [],
  RESERVED: ["AVAILABLE"],
  SOLD: ["RESERVED"],
  DELIVERED: ["SOLD"],
};

export const VEHICLE_STATO_LABELS = {
  usato: "Usato",
  km_zero: "Km Zero",
  nuova: "Nuovo",
};

// Sprint 4G.B1 — Carrozzeria (campo nuovo, no consumer business)
export const VEHICLE_CARROZZERIA_LABELS = {
  berlina: "Berlina",
  cabrio: "Cabrio",
  city_car: "City car",
  coupe: "Coupè",
  furgoni_van: "Furgoni / Van",
  monovolume: "Monovolume",
  station_wagon: "Station Wagon",
  suv_fuoristrada_pickup: "Suv / Fuoristrada / Pick-up",
  hatchback: "Hatchback",
  crossover: "Crossover",
  altro: "Altro",
};

export const VEHICLE_CARBURANTE_LABELS = {
  benzina: "Benzina",
  diesel: "Diesel",
  gpl: "GPL",
  metano: "Metano",
  ibrido_benzina: "Ibrido/Benzina",
  ibrido_diesel: "Ibrido/Diesel",
  elettrica: "Elettrica",
  // Sprint 4G.B3 — ampliato
  etanolo: "Etanolo",
  idrogeno: "Idrogeno",
  altro: "Altro",
};

export const VEHICLE_CAMBIO_LABELS = {
  manuale: "Manuale",
  automatico: "Automatico",
  // Sprint 4G.B3 — ampliato
  semiautomatico: "Semiautomatico",
  automatico_doppia_frizione: "Automatico Doppia Frizione",
  automatico_cvt: "Automatico CVT",
};

// Sprint 4G.B3 — Nuovi enum
export const VEHICLE_TIPO_CARBURANTE_LABELS = {
  benzina_91: "Benzina 91",
  super_95: "Super 95",
  super_plus_98: "Super Plus 98",
  benzina_e10_91: "Benzina E10 91",
  super_e10_95: "Super E10 95",
  super_plus_e10_98: "Super Plus E10 98",
};

export const VEHICLE_COLORE_LABELS = {
  nero: "Nero",
  grigio: "Grigio",
  argento: "Argento",
  bianco: "Bianco",
  arancione: "Arancione",
  beige: "Beige",
  blu_azzurro: "Blu / Azzurro",
  bronzo: "Bronzo",
  giallo: "Giallo",
  lilla: "Lilla",
  marrone: "Marrone",
  oro: "Oro",
  rosso: "Rosso",
  verde: "Verde",
};

// Sprint SCHEDA-VEICOLO — codice colore per il quadratino accanto al nome (stesse chiavi dei due elenchi).
// Una voce senza codice («altro») non mostra quadratino.
export const VEHICLE_COLORE_HEX = {
  nero: "#111111",
  grigio: "#7A7D80",
  argento: "#C0C3C7",
  bianco: "#FFFFFF",
  arancione: "#F07A1A",
  beige: "#D8C6A2",
  blu_azzurro: "#1F4E9C",
  bronzo: "#8C6A3F",
  giallo: "#F2C511",
  lilla: "#B39DDB",
  marrone: "#6B4226",
  oro: "#C9A23F",
  rosso: "#C62828",
  verde: "#2E7D32",
};

export const VEHICLE_COLORE_INTERNI_LABELS = {
  nero: "Nero",
  grigio: "Grigio",
  bianco: "Bianco",
  arancione: "Arancione",
  beige: "Beige",
  blu_azzurro: "Blu / Azzurro",
  giallo: "Giallo",
  marrone: "Marrone",
  rosso: "Rosso",
  verde: "Verde",
  altro: "Altro",
};

export const VEHICLE_MATERIALE_INTERNI_LABELS = {
  stoffa: "Stoffa",
  alcantara: "Alcantara",
  pelle_totale: "Pelle Totale",
  pelle_parziale: "Pelle Parziale",
  pelle_scamosciata: "Pelle Scamosciata",
  altro: "Altro",
};

// Sprint 4G.B4 — Classe ambientale
export const VEHICLE_CLASSE_AMBIENTALE_LABELS = {
  euro_1: "Euro 1",
  euro_2: "Euro 2",
  euro_3: "Euro 3",
  euro_4: "Euro 4",
  euro_5: "Euro 5",
  euro_6: "Euro 6",
  euro_6b: "Euro 6b",
  euro_6c: "Euro 6c",
  euro_6d: "Euro 6d",
  euro_6d_temp: "Euro 6d-TEMP",
  euro_6e: "Euro 6e",
};

export const VEHICLE_TRAZIONE_LABELS = {
  anteriore: "Anteriore",
  posteriore: "Posteriore",
  integrale: "Integrale (4x4)",
};

export const VEHICLE_TIPO_COLORE_LABELS = {
  metallizzato: "Metallizzato",
  pastello: "Pastello",
  opaco: "Opaco",
  perlato: "Perlato",
  micalizzato: "Micalizzato",
};

export const VEHICLE_DEPOSITO_LABELS = {
  in_uso_proprietario: "In uso al Proprietario",
  dal_fornitore: "Dal Fornitore",
};

// ----------------------------------------------------------------------------
// Sprint 2B.2-A bug-fix: deposito è ora object {tipo, sede_id} (post migrazione).
// Helper per renderizzare in modo sicuro una stringa user-facing in IT.
// ----------------------------------------------------------------------------
const DEPOSITO_TIPO_LABELS = {
  in_uso_proprietario: "In uso al proprietario",
  dal_fornitore: "Da azienda fornitore",
};

export function formatDeposito(deposito, allSites = []) {
  if (!deposito) return "—";
  if (typeof deposito === "string") {
    // Safety net per stringhe legacy sopravvissute alla migrazione.
    return DEPOSITO_TIPO_LABELS[deposito] || "—";
  }
  if (typeof deposito === "object") {
    if (deposito.tipo === "sede") {
      const sede = (allSites || []).find((s) => s.id === deposito.sede_id);
      return sede ? `c/o ${sede.nome}` : "c/o sede sconosciuta";
    }
    return DEPOSITO_TIPO_LABELS[deposito.tipo] || "—";
  }
  return "—";
}

export const VEHICLE_TIPO_CARICO_LABELS = {
  conto_proprio_art36: "Conto Proprio (art. 36)",
  conto_proprio_iva: "Conto Proprio IVA",
  conto_terzi: "Conto Terzi",
  conto_terzi_iva: "Conto Terzi IVA",
};

// Sprint 4Z.1 D5: abbreviazioni per la lista (compatte). In scheda dettaglio
// resta l'etichetta estesa di VEHICLE_TIPO_CARICO_LABELS.
export const VEHICLE_TIPO_CARICO_COMPACT_LABELS = {
  conto_proprio_art36: "CP",
  conto_proprio_iva: "CP Iva",
  conto_terzi: "CT",
  conto_terzi_iva: "CT Iva",
};

export function tipoCaricoCompact(value) {
  return VEHICLE_TIPO_CARICO_COMPACT_LABELS[value] || value || "—";
}

export const VEHICLE_PROVENIENZA_LABELS = {
  italia: "Italia",
  importazione: "Importazione",
};

export const VEHICLE_TAGLIANDO_TIPO_LABELS = {
  data: "A data",
  preconsegna: "Alla preconsegna",
};

export const SUPPLIER_CATEGORY_LABELS = {
  fornitore_veicoli: "Fornitore Veicoli",
  gommista: "Gommista",
  carrozzeria: "Carrozzeria",
  meccanico: "Meccanico",
  agenzia_pratiche: "Agenzia Pratiche",
  assicurazione: "Assicurazione",
  finanziaria: "Finanziaria",
  trasporti: "Trasporti",
  altro: "Altro",
};

export const SUPPLIER_TIPO_LABELS = {
  privato: "Privato",
  azienda: "Azienda",
};
